import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import location from "../assets/img/location.png";
import email from "../assets/img/email.png";
import phone from "../assets/img/phone.png";

function Contact3() {
  return (
    <div className="container mx-auto">
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center px-24">
          <div className="h-96 w-full bg-map bg-cover bg-center rounded-lg"></div>

          <div className="flex w-full mt-10">
            <p className="text-gray-800 w-1/2 text-4xl font-bold">코끼리협동조합</p>
            <div className="flex flex-col w-1/2 gap-3">
              {/* location */}
              <div className="flex items-center gap-5 pb-3 border-b border-gray-300">
                <img src={location} alt="logo" className="h-5" />
                <p className="text-gray-600 text-lg">광주 광역시 북구 무등로 190</p>
              </div>
              {/* phone */}
              <div className="flex items-center gap-5 pb-3 border-b border-gray-300">
                <img src={phone} alt="logo" className="h-5" />
                <p className="text-gray-600 text-lg">062-513-2014</p>
              </div>
              {/* email */}
              <div className="flex items-center gap-5 pb-3 border-b border-gray-300">
                <img src={email} alt="logo" className="h-5" />
                <p className="text-gray-600 text-lg">co77iri@gmail.com</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Contact3;
